<div id="generalInformationSection">
  <h5 class="p-16 m-0">Version History</h5>
  <mat-divider></mat-divider>
  <div class="versionHistory-height enableScroll">
    @if (versions.length === 0) {
      <div class="empty_grid_container">
        <p>No former versions to be displayed</p>
        <app-no-document-found class="icon-layout"></app-no-document-found>
      </div>
    }
    @for (version of versions; track version) {
      <div class="flex-column mt-16 ml-16 mb-16 gap-10">
        <div class="row-container gap-10">
          <div class="flex-column gap-5 w-p-70">
            <div class="row-container" >
              <div
                class="black-bold-text text-overflow-ellipsis w-13-vw"
                matTooltipClass="tooltip-style"
                matTooltipPosition="above"
                appMatTooltip="{{ version.FileName }}"
                [attr.id]="buildControlId('file-name', version.Id)"
                >
                {{ version.FileName }}
                @if (version.ChecksumStatus==='VerifiedAndCorrupted' && version.FileName.length < 30) {
                  <span
                    class="font-l icon-ic-warning color-error cursor ml-5"
                    matTooltipClass="tooltip-style"
                    matTooltipPosition="above"
                    matTooltip="There is an issue with the file integrity. Please, contact support."
                    [attr.id]="buildControlId('checksum-warning-inline', version.Id)"
                  ></span>
                }
              </div>
              @if (version.ChecksumStatus==='VerifiedAndCorrupted' && (version.FileName.length > 30 || version.FileName.length === 30)) {
                <span
                  class="font-l icon-ic-warning color-error cursor ml-5"
                  matTooltipClass="tooltip-style"
                  matTooltipPosition="above"
                  matTooltip="There is an issue with the file integrity. Please, contact support."
                  [attr.id]="buildControlId('checksum-warning-block', version.Id)"
                ></span>
              }
              <button  class="h-20 info-btn"
                matTooltipClass="tooltip-style"
                matTooltipPosition="above"
                matTooltip="Original file metadata"
                mat-icon-button
                [attr.id]="buildControlId('info-button', version.Id)"
              (click)="
                $event.stopPropagation();
                onInfoClick(
                  $event,
                  version.ExtensionForFile,
                  version.FileLastModifiedOn,
                  version.Size
                )
              ">
                <span class="icon-ic-info flexCenterAlign font-xl pointCursor color-link p-l-s"></span>
              </button>
              <ng-container >
                @if (version.IsMalicious) {
                  <span class="maliciousTag"> Malicious File</span>
                }
              </ng-container>
            </div>
            <div class="secondary-text">
              {{ version.CreatedOn + "Z" | date : "dd MMM yyyy | HH:mm " }}
            </div>
          </div>
          <div class="d-flex gap-10 w-p-15">
            <div class="download-icon blue-text cursor-pointer">
              <span
                class="icon-ic-download"
                matTooltip="Download"
                matTooltipClass="tooltip-style"
                [attr.id]="buildControlId('download', version.Id)"
                (click)="downloadFileVersion(version.UIVersion)"
              ></span>
            </div>
            <div class="align-self-start tag versionTag chip-version">
              {{ version.UIVersion }}
            </div>
          </div>
        </div>
        <div class="row-container w-100">
          <div class="d-flex w-p-70">
            <mat-chip-listbox aria-label="tags" class="w-100">
              @for (tag of version.TagsToBeDisplayed; track tag; let tagIndex = $index) {
                <mat-chip-option class="custom-chip w-p-45"
                  color="accent"
                  matTooltipClass="tooltip-style"
                  matTooltipPosition="above"
                  matTooltip="{{ tag?.TagValue }}"
                  [attr.id]="buildControlId('tag-chip', version.Id + '-' + tagIndex)"
                  >
                  {{ tag?.TagValue }}
                </mat-chip-option>
              }
            </mat-chip-listbox>
          </div>
          @if (version.TagsCount > 2) {
            <span
              class="blue-text cursor-pointer pt-12 w-p-20"
              [attr.id]="buildControlId('tags-more', version.Id)"
              (click)="overlaydisplay(version.TagVersions, $event)"
              >
              +{{ version.TagsCount - 2 }} more
            </span>
          }
        </div>
        <div class="row-container horizontal-center-align gap-10 blue-text">
          <div
            class="text-overflow-ellipsis gap-5 w-p-70"
            matTooltipClass="tooltip-style"
            matTooltipPosition="above"
            matTooltip="{{ version.StreamHash }}"
            [attr.id]="buildControlId('stream-hash', version.Id)"
            >
            {{ version.StreamHash }}
          </div>
          <div class="d-flex w-p-15">
            <button
              mat-icon-button
              (click)="copyToClipBoard(version.StreamHash)"
              matTooltipClass="tooltip-style"
              matTooltipPosition="above"
              [matTooltip]="'Copy'"
              [attr.id]="buildControlId('copy-stream-hash', version.Id)"
              >
              <span class="icon-ic-copy"></span>
            </button>
            <button
              class="mr-5"
              mat-icon-button
              rippleOnHover
              matTooltipClass="tooltip-style"
              matTooltipPosition="above"
              [matTooltip]="'Regenerate Checksum'"
              [attr.id]="buildControlId('regenerate-checksum', version.Id)"
              (click)="regenerateChecksum(version.Id)"
              >
              <span class="icon-ic-regenerate"></span>
            </button>
          </div>
        </div>
      </div>
      <mat-divider></mat-divider>
    }
  </div>
</div>
